<div class="flex gap-5 flex-wrap w-full">
  <div class="d-flex gap-5 w-full">
    <div class="d-flex flex-col gap-2 w-full group-form">
      <span class="font-medium required">End</span>
      <select
        cjInput
        class="form-control"
        name="EndType"
        [(ngModel)]="
          parent.recurringInvoiceConfig.RecurringFrequency.EndType
        "
        (change)="
          parent.recurringInvoiceConfig.RecurringFrequency.EndType =
            $event.target.value
        "
        required
      >
        <option value="1">Never</option>
        <!-- <option value="2">Until</option> -->
        <option value="3">Count</option>
      </select>
    </div>
    <cj-form-field
      *ngIf="parent.recurringInvoiceConfig.RecurringFrequency.EndType == 2"
    >
      <cj-form-label>End Date</cj-form-label>
      <input
        cjInput
        type="date"
        class="form-control"
        [min]="parent.dtInvoiceDate"
        [ngModel]="
          parent.recurringInvoiceConfig.RecurringFrequency.Until
            | date: 'yyyy-MM-dd'
        "
        required
        (ngModelChange)="
          parent.recurringInvoiceConfig.RecurringFrequency.Until = $event
        "
        [ngClass]="{
          'is-invalid':
            !parent.recurringInvoiceConfig.RecurringFrequency.Until
        }"
        name="RecurrenceUntil"
        required
      />
    </cj-form-field>
    <cj-form-field
      *ngIf="parent.recurringInvoiceConfig.RecurringFrequency.EndType == 3"
    >
      <cj-form-label>Count</cj-form-label>
      <input
        cjInput
        type="number"
        class="form-control"
        name="Count"
        [(ngModel)]="
          parent.recurringInvoiceConfig.RecurringFrequency.Count
        "
        required
      />
    </cj-form-field>
  </div>

  <div class="d-flex gap-5 w-full">
    <div class="d-flex flex-col gap-2 w-full group-form">
      <span class="font-medium required">Repeat Option</span>
      <select
        cjInput
        class="form-control"
        name="FrequencyType"
        [(ngModel)]="
          parent.recurringInvoiceConfig.RecurringFrequency.FrequencyType
        "
        (change)="changeRecurringFrequencyType($event)"
        required
      >
        <option value="1">Daily</option>
        <option value="2">Weekly</option>
        <option value="3">Monthly</option>
        <option value="4">Yearly</option>
      </select>
    </div>
    <cj-form-field>
      <cj-form-label>Repeat Every</cj-form-label>
      <div class="d-flex gap-5 items-center">
        <input
          cjInput
          type="number"
          class="form-control"
          [min]="1"
          [(ngModel)]="
            parent.recurringInvoiceConfig.RecurringFrequency.Interval
          "
          name="Interval"
          required
        />
        <span class="text-base font-medium">{{
          repeatitionLabel[
            parent.recurringInvoiceConfig.RecurringFrequency.FrequencyType
          ]
        }}</span>
      </div>
    </cj-form-field>
  </div>

  <div class="d-flex flex-col gap-5 w-full">
    <div
      class="d-flex gap-3 self-start"
      *ngIf="
        parent.recurringInvoiceConfig.RecurringFrequency.FrequencyType ===
        3
      "
    >
      <button
        cjButton
        [appearance]="
          parent.recurringInvoiceConfig.RecurringFrequency.DayType ===
          'day'
            ? 'filled'
            : 'outline'
        "
        status="primary"
        type="button"
        (click)="changeRecurringDayType('day')"
      >
        Day of the month
      </button>
      <button
        [appearance]="
          parent.recurringInvoiceConfig.RecurringFrequency.DayType ===
          'month'
            ? 'filled'
            : 'outline'
        "
        cjButton
        status="primary"
        type="button"
        (click)="changeRecurringDayType('month')"
      >
        Week of the month
      </button>
    </div>
    <div
      class="d-flex gap-3 w-full items-center"
      *ngIf="
        parent.recurringInvoiceConfig.RecurringFrequency.FrequencyType ===
        4
      "
    >
      <div class="d-flex flex-col gap-2 w-full group-form">
        <span class="font-medium required">Repeat on</span>
        <select
          cjInput
          class="form-control"
          name="ByMonth"
          [(ngModel)]="
            parent.recurringInvoiceConfig.RecurringFrequency.ByMonth
          "
          (change)="changeRecurringByMonth($event)"
          required
        >
          <option value="1">January</option>
          <option value="2">February</option>
          <option value="3">March</option>
          <option value="4">April</option>
          <option value="5">May</option>
          <option value="6">June</option>
          <option value="7">July</option>
          <option value="8">August</option>
          <option value="9">September</option>
          <option value="10">October</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </select>
      </div>
    </div>
    <div
      class="d-flex gap-3 w-full items-center"
      *ngIf="
        parent.recurringInvoiceConfig.RecurringFrequency.DayType ===
          'day' &&
        parent.recurringInvoiceConfig.RecurringFrequency.FrequencyType ===
          3
      "
    >
      Every
      <input
        type="number"
        class="form-control"
        style="width: 75px !important"
        [min]="1"
        [(ngModel)]="
          parent.recurringInvoiceConfig.RecurringFrequency.ByMonthDay
        "
        required
        [ngClass]="{
          'is-invalid':
            !parent.recurringInvoiceConfig.RecurringFrequency.ByMonthDay
        }"
        name="ByMonthDay"
      />
      of the month
    </div>
    <div class="d-flex gap-3 w-full">
      <select
        *ngIf="
          parent.recurringInvoiceConfig.RecurringFrequency.DayType ===
            'month' &&
          parent.recurringInvoiceConfig.RecurringFrequency
            .FrequencyType === 3
        "
        cjInput
        class="form-control w-24"
        name="BySetPos"
        [(ngModel)]="
          parent.recurringInvoiceConfig.RecurringFrequency.BySetPos
        "
        (change)="changeRecurringBySetPos($event)"
      >
        <option value="1">First</option>
        <option value="2">Second</option>
        <option value="3">Third</option>
        <option value="4">Fourth</option>
        <option value="5">Last</option>
      </select>
      <div
        class="d-flex gap-3"
        *ngIf="
          parent.recurringInvoiceConfig.RecurringFrequency
            .FrequencyType === 2 ||
          (parent.recurringInvoiceConfig.RecurringFrequency.DayType ===
            'month' &&
            parent.recurringInvoiceConfig.RecurringFrequency
              .FrequencyType === 3)
        "
      >
        <button
          type="button"
          class="border-0 font-medium h-8 ng-star-inserted rounded-circle text-white w-8"
          *ngFor="let day of daysInWeek | keyvalue: originalOrder"
          [ngClass]="
            parent.recurringInvoiceConfig.RecurringFrequency.ByDay.includes(
              day.key
            )
              ? 'bg-blue-90'
              : 'bg-gray-60'
          "
          (click)="changeRecurringByDay(day.key, 'multiple')"
        >
          {{ day.value }}
        </button>
      </div>
    </div>
  </div>

  <div class="d-flex flex-col gap-3">
    <cj-form-label class="font-medium"
      >Send email reminder before billing date</cj-form-label
    >
    <div class="d-flex gap-5 items-center">
      <div class="d-flex flex-col gap-2 w-full group-form">
        <select
          cjInput
          class="form-control"
          [(ngModel)]="parent.recurringInvoiceConfig.ReminderFrequencyType"
          name="ReminderFrequencyType"
          required
        >
          <option value="Day">Days</option>
          <option value="Week">Weeks</option>
          <option value="Month">Months</option>
        </select>
      </div>
      <input
        cjInput
        type="number"
        class="form-control"
        [(ngModel)]="parent.recurringInvoiceConfig.ReminderFrequencyValue"
        name="ReminderFrequencyValue"
        required
      />
    </div>
  </div>
</div>
